"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var BottomNavigationBarStyle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  bottom: 0;\n  z-index: 201;\n  display: flex;\n  width: 100%;\n  height: ", ";\n  overflow: hidden;\n  background: ", ";\n"], ["\n  position: fixed;\n  bottom: 0;\n  z-index: 201;\n  display: flex;\n  width: 100%;\n  height: ", ";\n  overflow: hidden;\n  background: ", ";\n"])), function (p) { return p.height + 'px'; }, function (_a) {
    var colours = _a.theme.colours;
    return colours.bottomNavigationBar.background;
});
exports.NavigationListItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  color: ", ";\n  border-top: ", ";\n"], ["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ",
    ";\n  color: ",
    ";\n  border-top: ",
    ";\n"])), function (_a) {
    var colours = _a.theme.colours, active = _a.active;
    return active ? colours.bottomNavigationTab.navSelected : colours.bottomNavigationTab.background;
}, function (_a) {
    var colours = _a.theme.colours, active = _a.active;
    return active ? colours.bottomNavigationTab.textColorHover : colours.bottomNavigationTab.textColor;
}, function (_a) {
    var colours = _a.theme.colours, active = _a.active;
    return active
        ? '4px solid ' + colours.bottomNavigationTab.activeTopBorder
        : '4px solid ' + colours.bottomNavigationBar.background;
});
var NavigationListItemsWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var NavigationListItemIcon = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  margin-bottom: 4px;\n\n  svg {\n    fill: ", ";\n  }\n"], ["\n  width: 24px;\n  height: 24px;\n  margin-bottom: 4px;\n\n  svg {\n    fill: ",
    ";\n  }\n"])), function (_a) {
    var colours = _a.theme.colours, active = _a.active;
    return active ? colours.bottomNavigationTab.textColorActive : colours.bottomNavigationTab.textColor;
});
exports.NavigationListItemText = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 12px;\n  line-height: 13px;\n  color: ", ";\n  text-align: center;\n"], ["\n  font-size: 12px;\n  line-height: 13px;\n  color: ",
    ";\n  text-align: center;\n"])), function (_a) {
    var colours = _a.theme.colours, active = _a.active;
    return active ? colours.bottomNavigationTab.textColorActive : colours.bottomNavigationTab.textColor;
});
var BottomNavigationBar = function (_a) {
    var tabs = _a.tabs, onTabClick = _a.onTabClick, activeTabLink = _a.activeTabLink, height = _a.height;
    var handleNavbarClick = function (tab) {
        onTabClick(tab);
    };
    var isTabActive = function (tab) {
        return tab.link === activeTabLink;
    };
    return (react_1.default.createElement(BottomNavigationBarStyle, { height: height, "data-test-id": "bottom-navigation-bar" }, tabs.map(function (tab) { return (react_1.default.createElement(exports.NavigationListItem, { key: tab.key, active: isTabActive(tab), onClick: function () { return handleNavbarClick(tab); } },
        react_1.default.createElement(NavigationListItemsWrapper, null,
            react_1.default.createElement(NavigationListItemIcon, { active: isTabActive(tab) },
                react_1.default.createElement(tab.icon, null)),
            react_1.default.createElement(exports.NavigationListItemText, { active: isTabActive(tab) }, tab.tabText)))); })));
};
exports.default = BottomNavigationBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=bottom-navigation-bar.component.js.map